import React from "react";
import { DynamicTable } from "@maherunlocker/custom-react-table";

import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { t } from "i18next";

export default function ModalStore({
    id_franshise,
    shopId,
    onAddProducts,
    onClose,
}: {
    id_franshise: string;
    shopId: string;
    onAddProducts: (products: any[]) => void;
    onClose: () => void;
}) {
    const i18nextLng = localStorage.getItem("i18nextLng") || "";
    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);

    const handleValidate = () => {
        if (selectedRows.length > 0) {
            onAddProducts(selectedRows);
            onClose();
        }
    };

    return (
        <React.Fragment>
            <div className="style-table__clz">
                <DynamicTable
                    url={`${process.env.REACT_APP_CATALOGUE_ARTICLES}${id_franshise}/${shopId}`}
                    showGlobalFilter
                    requestHeader={{ "Accept-Language": i18nextLng }}
                    elevationTable={1}
                    minHeight="530px"
                    maxHeight="570px"
                    canSelect
                    filterActive={filterActive}
                    setLocalFilterActive={setLocalFilterActive}
                    customSelect
                    setSelectedRows={setSelectedRows}
                />
            </div>
            <div>
                <div className="justify-content-between d-flex align-items-right float-right p-3 mt-3">
                    <CustomSecondaryColorButton
                        outline
                        rounded
                        className="mr-2 cmn_btn_cancelAlert"
                        variant="light"
                        onClick={onClose}
                    >
                        <span>{t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        variant="primary"
                        className="cmn_btn_validateAlert"
                        onClick={handleValidate}
                        disabled={selectedRows.length === 0}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </div>
            </div>
        </React.Fragment>
    );
}
